/*
  "Join our community" sign-up on the blog (snippets/magnum-blog-signup.liquid).
  Sends the email straight to Klaviyo's newsletter list - the same list the
  15% off pop-up uses - so the page doesn't reload. On success the heading
  becomes the thank-you and the form is taken away.
  Shopify's own customer form can't be posted in the background (it runs a
  hidden robot check), which is why this goes to Klaviyo instead.
*/
(function () {
  if (window.magnumBlogSignup) return;
  window.magnumBlogSignup = true;

  const KLAVIYO_ACCOUNT = 'W9kFLP';
  const NEWSLETTER_LIST = 'VmEnvL';

  function setup(card) {
    const form = card.querySelector('form');
    if (!form || form.dataset.mbReady) return;
    form.dataset.mbReady = 'true';

    const email = form.querySelector('input[type="email"]');
    const button = form.querySelector('button[type="submit"]');
    const error = form.querySelector('[data-mb-signup-error]');
    const label = button.textContent;

    function showError(message) {
      error.textContent = message;
      error.hidden = false;
    }

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      error.hidden = true;

      const value = email.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        showError('Please enter a valid email address.');
        email.focus();
        return;
      }

      button.disabled = true;
      button.textContent = 'Joining…';

      try {
        const response = await fetch(
          `https://a.klaviyo.com/client/subscriptions?company_id=${KLAVIYO_ACCOUNT}`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/vnd.api+json',
              revision: '2025-01-15',
            },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: 'Blog - Join our community',
                  profile: { data: { type: 'profile', attributes: { email: value } } },
                },
                relationships: {
                  list: { data: { type: 'list', id: NEWSLETTER_LIST } },
                },
              },
            }),
          }
        );

        if (!response.ok) throw new Error(response.status);

        card.querySelector('[data-mb-signup-heading]').textContent = 'Thanks for joining our community!';
        card.querySelector('[data-mb-signup-text]').innerHTML =
          '<p>Keep an eye on your inbox for our expert tips.</p>';
        form.remove();
        card.classList.add('is-joined');
      } catch (e) {
        showError("Sorry, that didn't go through. Please try again.");
        button.disabled = false;
        button.textContent = label;
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-mb-signup]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
